import { render, staticRenderFns } from "./AdminTableActionButton.vue?vue&type=template&id=3652aa02&scoped=true&"
import script from "./AdminTableActionButton.vue?vue&type=script&lang=js&"
export * from "./AdminTableActionButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../src/web/assets/admintable/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3652aa02",
  null
  
)

export default component.exports